import React from 'react';
import { BsFillEnvelopeFill } from "react-icons/bs";
import { BiPhoneOutgoing } from "react-icons/bi";

const Footer = () => {
    return (
        <div className="footer">
            <div className="maps">
                <img src="/mapS.jpg" />
            </div>


            <div className="contact-us">
                <h2>Contact us</h2>
                <p><BiPhoneOutgoing />  +1-682-292-8560</p>
                <p><BsFillEnvelopeFill /> rssboysmounting@gmail.com</p>


            </div>

            <div className="contact-us-mobile-view">
                <h2>Contact us</h2>

                <a href="tel:6822928560" ><BiPhoneOutgoing /> Call +1-682-292-8560</a>
                <br />
                <a href="mailto: rssboysmounting@gmail.com"><BsFillEnvelopeFill /> rssboysmounting@gmail.com </a>

            </div>


        </div>



    );
}

export default Footer;